var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenai(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 269 269",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 268.272,
    height: 268.272,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M169.354,83.857c0.686,-1.758 2.376,-2.914 4.257,-2.914c1.881,0 3.571,1.156 4.257,2.914l16.014,40.99l40.841,16.072c1.752,0.69 2.904,2.385 2.904,4.273c-0,1.888 -1.152,3.584 -2.904,4.273l-40.841,16.072l-16.014,40.99c-0.686,1.758 -2.376,2.914 -4.257,2.914c-1.881,0 -3.571,-1.156 -4.257,-2.914l-16.014,-40.99l-40.841,-16.072c-1.752,-0.689 -2.904,-2.385 -2.904,-4.273c0,-1.888 1.152,-3.583 2.904,-4.273l40.841,-16.072l16.014,-40.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.446,34.516c0.542,-1.389 1.877,-2.302 3.363,-2.302c1.486,-0 2.821,0.913 3.364,2.302l12.651,32.383l32.265,12.697c1.384,0.545 2.294,1.884 2.294,3.376c-0,1.491 -0.91,2.831 -2.294,3.375l-32.265,12.698l-12.651,32.382c-0.543,1.389 -1.878,2.303 -3.364,2.303c-1.486,-0 -2.821,-0.914 -3.363,-2.303l-12.651,-32.382l-32.265,-12.698c-1.384,-0.544 -2.294,-1.884 -2.294,-3.375c-0,-1.492 0.91,-2.831 2.294,-3.376l32.265,-12.697l12.651,-32.383Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.571,162.661c0.401,-1.027 1.388,-1.703 2.488,-1.703c1.099,-0 2.087,0.676 2.488,1.703l9.359,23.956l23.87,9.394c1.023,0.403 1.697,1.394 1.697,2.497c-0,1.104 -0.674,2.094 -1.697,2.497l-23.87,9.394l-9.359,23.956c-0.401,1.027 -1.389,1.703 -2.488,1.703c-1.1,0 -2.087,-0.676 -2.488,-1.703l-9.359,-23.956l-23.87,-9.394c-1.023,-0.403 -1.697,-1.393 -1.697,-2.497c0,-1.103 0.674,-2.094 1.697,-2.497l23.87,-9.394l9.359,-23.956Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenai);
export default __webpack_public_path__ + "static/media/genai.f1e583511f70db624add10737919181b.svg";
export { ForwardRef as ReactComponent };